<script>
    import { onMount, onDestroy } from 'svelte'

    let loader
    let circuit
    let intervalId = -1

    async function initLoader () {
        await SVGInject(circuit, { makeIdsUnique: false })

        const layers = ['#Layer1', '#Layer2', '#Layer3'].map(id => loader.querySelector(id))
        const opacities = [1, 0.3, 0]

        let activeLayer = 0
        const animate = () => {
            for (let i = 0; i < 3; i++) {
                layers[(activeLayer + i) % 3].style.opacity = opacities[i]
            }
            activeLayer++
        }

        intervalId = setInterval(animate, 1200)
    }

    onMount(() => {
        initLoader()
    })

    onDestroy(() => {
        clearInterval(intervalId)
    })

</script>

<div class="loaderContainer" bind:this={loader}>
    <img
        class="loadingCircuit"
        src="assets/favicon-repressilator-01.svg"
        alt="loading icon"
        bind:this={circuit}
    />
    <h2>Loading</h2>
</div>

<style lang="scss">
    .loaderContainer {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        h2 {
            font-family: "Ysabeau";
            font-weight: 400;
        }
    }

    :global(.loadingCircuit) {
        max-width: 250px;
        max-height: 250px;
    }

    :global(.loadingCircuit g) {
        transition: opacity 0.3s ease;
    }
</style>
